Eshop.alert = function (msg, options) {
    var settings = $.extend({
        allow_dismiss: true,
        type: 'success',
        animate: {
            enter: 'fadeInRight',
            exit: 'fadeOutRight'
        },
        placement: {
            from: checkResolution('cxs;xs') ? 'bottom' : 'top'
        },
        gap: 2,
        delay: 4500,
        mouse_over: 'pause',
        offset: {
            y: checkResolution('cxs;xs') ? 15 : 85,
            x: 0
        },
        z_index: 3003,
        template:
            '<div data-notify="container" class="notify custom {0}" role="alert">' +
            '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
            '<i class="ico ico-close" aria-hidden="true"></i>' +
            '</button>' +
            '<span class="message" data-notify="message">{2}</span>' +
            '</div>'
    }, options);

    $.notify(msg, settings);
}

Cart.addItem = function (form) {
    if ($(form).hasClass('is-rent')) {
        let $rentError = $(form).siblings('.js-rent-length-error');
        let $rentInput = $(form).find('.js-rent-length-input');

        $rentError.slideUp(150);

        if (!$rentInput.val() && false) {
            $rentError.stop(true, false).slideDown(150);

            return false;
        }
    }

    var $quantityInput = $(form).find('input[name="quantity"]');

    if ($quantityInput.size() == 1 && $quantityInput.val() && parseInt($quantityInput.val()) < 1) {
        $quantityInput.val(Math.abs($quantityInput.val()));
    }

    Eshop.preloader.show();
    rEvent.dispatch('Cart.product.before_add', form);

    Form.ajaxPost(form, function (response) {
        Cart.callbacks.addedItem(form, response);
        rEvent.dispatch('Cart.product.after_add', response);
    }, 'json');

    return false;
};

Cart.customCallbacks.addedItem = function (form, response) {
    var $submitButton = $(form).find('[type="submit"]');

    if (!response.status) {
        $submitButton.addClass('has-error');
    }

    $submitButton
        .addClass('is-loaded')
        .removeClass('is-loading')
        .prop('disabled', false);

    if (checkResolution('ie')) {
        setTimeout(function () {
            $submitButton.removeClass('is-loaded');
        }, 1000);
    } else {
        $submitButton.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
            $submitButton.removeClass('is-loaded');
        });
    }
}

rEvent.on('Cart.product.before_add', function (form) {
    $(form).find('[type="submit"]')
        .removeClass('has-error')
        .addClass('is-loading')
        .prop('disabled', true);
});

rEvent.on('Listing.fetchedData', function (data) {
    if ($('.pager__load').length && $('.pager__load').hasClass('is-loading')) {
        $('.pager__load').removeClass('is-loading');
    }

    bLazy.revalidate();

    setTimeout(function () {
        bLazy.revalidate();
    }, 250);
});

Url.getParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

$(function () {
    $(document).on('click', '.pager__load', function () {
        $(this).addClass('is-loading');
    });

    $('.js-custom-form-modal-login').validate({
        rules: {
            login: {
                email: true
            }
        },
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').addClass('is-loading');
            $('.js-login-error').slideUp(100);

            Form.ajaxPost(form, function (data) {
                if (!data.status) {
                    $('.js-login-error')
                        .text(data.message)
                        .slideDown(150);
                } else {
                    $('.js-login-hide').slideUp(150);
                    $('.js-login-success').slideDown(150);

                    location.reload();
                }

                $(form).find('button[type="submit"]').removeClass('is-loading');
            }, 'json');
        }
    });

    setTimeout(function () {
        jQuery.validator.addMethod("email", function (value, element) {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || value == '';
        });
    }, 0);
});

const favoritProductComponent = {
    props: ['addText', 'removeText', 'productId', 'iconBaseClass'],
    template: `
        <button class="c-btn js-detail-favorite" @click="clickCallback" :title="buttonText">
            <div :class="mainClass">
                <i :class="iconClass"></i>
                <span>{{ buttonText }}</span>
            </div>
        </button>
    `,
    data: function () {
        return {
            'storageKey': 'favoriteProducts',
            'storage': []
        }
    },
    created: function () {
        this.restoreStorage();
        this.updateBadge();

        this.$root.$on('favorite-change', this.updateBadge);
    },
    methods: {
        addProduct: function () {
            this.restoreStorage();

            this.storage.push(this.productId);
            localStorage.setItem(this.storageKey, JSON.stringify([...new Set(this.storage)]));

            setCookie('favorite-products-count', this.storage.length, 30);

            this.$root.$emit('favorite-change');
        },
        removeProduct: function () {
            this.restoreStorage();

            let index = this.storage.indexOf(this.productId);
            if (index === -1) {
                return false;
            }

            this.storage.splice(index, 1);
            localStorage.setItem(this.storageKey, JSON.stringify([...new Set(this.storage)]));

            setCookie('favorite-products-count', this.storage.length, 30);

            this.$root.$emit('favorite-change');
        },
        clickCallback: function () {
            if (!this.isFavorite) {
                this.addProduct();
                return;
            }

            this.removeProduct();
        },
        restoreStorage: function () {
            let storageProducts = localStorage.getItem(this.storageKey);
            this.storage = storageProducts ? JSON.parse(storageProducts) : [];

            // setCookie('favorite-products-count', this.storage.length, 30);
        },
        updateBadge: function () {
            var _self = this;

            $('.js-favorite-badge')
                .html(_self.storage.length)
                .toggleClass('is-empty', _self.storage.length == 0);
        }
    },
    computed: {
        isFavorite: function () {
            return this.storage.indexOf(this.productId) !== -1;
        },
        mainClass: function () {
            return {
                'is-add': !this.isFavorite,
                'is-remove': this.isFavorite
            };
        },
        iconClass: function () {
            const iconClasses = {
                'ico': true,
            }

            if (!this.isFavorite) {
                iconClasses[this.iconBaseClass] = true;
            } else {
                iconClasses[this.iconBaseClass + '-full'] = true;
            }

            return iconClasses
        },
        buttonText: function () {
            if (!this.isFavorite) {
                return this.addText;
            }

            return this.removeText;
        }
    }
};
Vue.component('favorite-product', favoritProductComponent);

function buildFavoriteComponents() {
    document.querySelectorAll('[data-component="favoriteProduct"]').forEach(element => {
        let dataset = element.dataset;
        let template = element.innerHTML.replace(/data-v-event-/g, '@').replace(/data-v-prop-/g, ':').trim();
        element.innerHTML = '';

        new Vue({
            el: element,
            template: `
                <span>
                    <favorite-product
                        :product-id="${dataset.productId}"
                        :add-text="\'${dataset.addText}\'"
                        :remove-text="\'${dataset.removeText}\'"
                        :icon-base-class="\'${dataset.iconBaseClass || 'ico-heart'}\'"
                        ${template ? 'inline-template' : ''}
                    >${template}</favorite-product>
                </span>
            `
        });
    });
}

buildFavoriteComponents();
rEvent.on('Listing.fetchedData', function (data) {
    buildFavoriteComponents();
});

const favoriteApp = document.getElementById('favorite-products-app');

if (favoriteApp) {
    new Vue({
        el: favoriteApp,
        store,
        data: {
            favoriteProducts: []
        },
        created: function () {
            const _self = this;

            this.restoreStorage();

            this.$on('favorite-change', this.restoreStorage);

            rEvent.on('ProductsStoreModule.failedFetchProduct', function (productId) {
                const storageProducts = JSON.parse(localStorage.getItem('favoriteProducts'));

                if (storageProducts) {
                    _self.restoreStorage();

                    let index = storageProducts.indexOf(productId);
                    if (index === -1) {
                        return false;
                    }

                    storageProducts.splice(index, 1);
                    localStorage.setItem('favoriteProducts', JSON.stringify([...new Set(storageProducts)]));
                    _self.$root.$emit('favorite-change');
                }
            });
        },
        template: $('#favoriTeProductsApp').html(),
        methods: {
            restoreStorage: function () {
                let storageProducts = localStorage.getItem('favoriteProducts');
                this.favoriteProducts = storageProducts ? JSON.parse(storageProducts) : [];

                setCookie('favorite-products-count', this.favoriteProducts.length, 30);
            }
        }
    });
}


var filterElem = document.getElementById("filter");

if (filterElem !== null) {
    filterElem.addEventListener("category.changed", function (e) {
        var categoryId = e.detail.category_id;

        document.getElementById('filterCategoryId').value = categoryId;
        Filter.submit();
    });

    filterElem.addEventListener("category.updated", function (e) {
        var category = e.detail.category;
        var headElem = document.getElementsByTagName('h1')[0];
        var heading = headElem.innerText;

        if (headElem.dataset.original === undefined) {
            headElem.dataset.original = heading;
        }

        headElem.innerText = headElem.dataset.original;
        if (category) {
            headElem.innerText += " - " + category.name;
        }
    });
}